// extracted by mini-css-extract-plugin
export default {"classification":"style_classification__6SF3f","configuration":"style_configuration__WU07k","finish":"style_finish__SCtUg","pricing":"style_pricing__xhMgY"};